<template>
  <van-overlay :lock-scroll="false" :show="showSku" @click="changeShow">
    <van-loading v-show="loadingSku" class="sku-loading" size="24px" vertical>加载中...</van-loading>
    <div :class="{short:isExchange}" class="wrapper flex">
      <div v-if="hasremindetime && mainId === 0" class="w-block">
        <van-notice-bar
          :scrollable="false"
          :text="computedNotice"
        />
      </div>
      <svg-icon :class="{'no-timer-icon':!hasremindetime || mainId !== 0}" class="close" icon-class="close" @click.prevent="showSku=true" />
      <div v-show="!loadingSku" :class="{'no-timer':!hasremindetime || mainId !== 0}" class="w-content" @click.stop>
        <div v-if="!isExchange" ref="wTitles" class="w-titles">
          <div class="pro-simple">
            <img :src="isDisabled || skuPic===null ? details.pic : skuPic" class="pro-img" alt="" @click.stop="showskuPre(isDisabled)">
            <span v-if="skuPrice!==undefined" class="price">¥ {{ skuPrice.toFixed(2) }}</span>
            <span v-else-if="details.minPrice && details.minPrice < details.maxPrice" class="price">¥ {{ details.minPrice.toFixed(2) || '0.00' }} ~ {{ details.maxPrice.toFixed(2)|| '0.00' }}</span>
            <span v-else class="price">¥ {{ details.minPrice ? details.minPrice.toFixed(2) : '0.00' }}</span>
          </div>
          <p class="w-title">{{ details.name || '' }}</p>
          <p class="buy">
            <span v-if="isDisabled"/>
            <span v-else-if="stock!==undefined && ~~details.productType !== 4" class="kc">剩余名额:{{ stock || 0 }}</span>
            <span v-else-if="stock!==undefined && ~~details.productType === 4" class="kc">剩余:{{ stock || 0 }}</span>
            <span v-else class="kc"/>
            <span v-if="isDisabled"/>
            <span v-if="~~details.productType === 4 || ~~details.productType === 5"/>
            <span v-else-if="courseCount===undefined && details.minCourseCount === 0 && details.maxCourseCount === 0"/>
            <span v-else-if="courseCount===undefined && !(details.minCourseCount === 0 && details.maxCourseCount === 0)" class="un">共{{ getBetween(details.minCourseCount, details.maxCourseCount) }}课次</span>
            <span v-else-if="courseCount===null || courseCount === 0"/>
            <span v-else class="counts">共{{ courseCount }}课次</span>
            <!-- <span v-else-if="details.minCourseCount !== null && details.maxCourseCount !== null" class="counts">共{{ details.minCourseCount || 0 }}-{{ details.maxCourseCount || 0 }}课次</span>
            <span v-else-if="details.minCourseCount !== null && details.maxCourseCount === null" class="counts">共{{ details.minCourseCount || 0 }}课次</span>
            <span v-else-if="details.maxCourseCount !== null && details.minCourseCount === null" class="counts">共{{ details.maxCourseCount || 0 }}课次</span>
            <span v-else-if="details.minCourseCount < details.maxCourseCount" class="counts">共{{ details.minCourseCount || 0 }}-{{ details.maxCourseCount || 0 }}课次</span> -->
          </p>
        </div>
        <div v-else ref="wTitles" class="w-titles">
          <p class="short-tip">请选择需要调整的内容</p>
        </div>
        <div ref="tDetails" class="t-details" @click.stop>
          <ul v-for="(val,vindex) in skuDetails.attributeList" :key="val.attributeId" class="w-type">
            <li class="s-title">{{ val.attributeName || '' }}</li>
            <li v-if="val.attributeType!=='1'" class="s-type">
              <span v-for="(item,sindex) in val.attributeValueList" :class="[item.isStock?'hide-small':'show-small', {'active-s-type':item.check}]" :key="item.skuIds" @click="changeProper(vindex,item,sindex)">
                <label>{{ item.attributeValue }}</label>
                <small v-if="item.isStock">已满</small>
              </span>
            </li>
            <li v-else class="t-list">
              <p v-for="(item,sindex) in val.attributeValueList" :class="[item.isStock?'hide-small':'show-small', {'active-s-teacher':item.check}]" :key="item.skuIds" class="t-block" @click="changeProper(vindex,item,sindex)">
                <img :src="item.pic || teacherAvatar" class="teacher-avatar" alt="">
                <span class="t-name">{{ item.attributeValue }}</span>
                <small v-if="item.isStock">已满</small>
              </p>
            </li>
          </ul>
          <div v-if="~~details.productType === 4" class="product-matter">
            <p class="s-title">数量</p>
            <div class="product-matter-operate flex flex-m">
              <van-stepper v-model="matter" :max="purchaseLimit" input-width="70px" button-size="28px" min="1" integer step="1" />
              <span v-if="purchaseLimit!==0" class="product-matter-label">单次限购{{ purchaseLimit }}个</span>
            </div>
          </div>
        </div>
      </div>
      <div class="w-footer" @click.stop>
        <van-button :disabled="isDisabled" type="info" @click="add">
          {{ buttonName }}
        </van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { getToken } from '@/utils/auth';
import { Toast, Icon, Overlay, NoticeBar, Button, Loading, Dialog, Stepper, ImagePreview } from 'vant';
import { generateOrder } from '../../api/order/index';
export default {
  name: 'courseDetails',
  components: {
    [Icon.name]: Icon,
    [Overlay.name]: Overlay,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Stepper.name]: Stepper,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  props: {
    showSku: {
      type: Boolean,
      default: false
    },
    isImmediatelyJoin: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    details: {
      type: Object,
      default: () => ({})
    },
    productSkuId: {
      type: Number,
      default: 0
    },
    quantity: {
      type: Number,
      default: 1
    },
    mainId: {
      type: Number,
      default: 0
    },
    computedNotice: {
      type: String,
      default: ''
    },
    getCourseTime: {
      type: String,
      default: ''
    },
    isExchange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingSku: false,
      skuDetails: { attributeList: [], skuList: [] },
      // 选中数组集合
      selectList: [],
      unSelectList: [],
      // 当前有数据的选中的总集合
      skuidsList: [],
      isDisabled: true,
      // sku 价格
      skuPrice: undefined,
      skuPic: undefined,
      // sku 库存
      stock: undefined,
      // 限购数量
      purchaseLimit: 0,
      // sku 课次
      courseCount: undefined,
      hasremindetime: false,
      day: '0',
      hour: '',
      minute: '',
      second: '',
      remainTime: '',
      canCommit: true,
      teacherAvatar: require('../../assets/img/course/icon-default-teacher.png'),
      matter: 1
    };
  },
  computed: {
    hourString() {
      return this.formatNum(this.hour);
    },
    minuteString() {
      return this.formatNum(this.minute);
    },
    secondString() {
      return this.formatNum(this.second);
    },
    buttonName() {
      if (this.isExchange) {
        return '确认修改';
      } else {
        return '确定';
      }
    }
  },
  watch: {
    skuDetails: {
      handler(val) {
        let sumNum = 0;
        let sumList = [];
        console.log(val.attributeList);
        val.attributeList.forEach((item) => {
          if (Object.prototype.toString.call(item.attributeValueList) === '[object Array]') {
            item.attributeValueList.forEach(ele => {
              if (ele.check) {
                sumNum += 1;
                sumList.push(ele.skuIds.split(','));
              }
            });
          }
        });
        this.skuPrice = undefined;
        this.stock = undefined;
        this.purchaseLimit = 0;
        this.courseCount = undefined;
        this.isDisabled = true;
        console.log(787887);
        // 判断是否都勾选中且库存
        if (sumNum === val.attributeList.length) {
          console.log('sumList', sumList);
          if (sumList.length > 1) {
            console.log(7678989);
            this.getMoreListCommon(sumList);
          } else {
            this.isDisabled = false;
            console.log(11111, sumList);
            this.skuidsList = sumList.length === 1 ? sumList[0] : [];
            this.skuDetails.skuList.forEach(item => {
              sumList.forEach(ele => {
                if (item.id.toString() === ele.toString()) {
                  console.log('item', item);
                  console.log('//////this.quantity', this.quantity, '8888', this.matter);
                  if (this.quantity === 1) {
                    this.matter = 1;
                  }
                  this.skuPrice = item.price || 0;
                  this.skuPic = item.pic;
                  this.stock = item.stock || 0;
                  console.log('item.purchaseLimit', item.purchaseLimit);
                  this.purchaseLimit = item.purchaseLimit || 0;
                  this.courseCount = item.courseCount;
                }
              });
            });
          }
          console.log(this.stock);
        } else {
          console.log(888);
          this.isDisabled = true;
        }
      },
      deep: true
    }
  },
  created() {
    if (this.productSkuId !== 0) {
      console.log(this.productSkuId);
      this.selectList = [];
      this.selectList.push({ skuIds: this.productSkuId, check: true });
    }
    this.matter = this.quantity;
    console.log('this.matter', this.matter);
    console.log(this.selectList);
    // 剩余时间s
    this.remainTime = this.details.remainTime;
    if (typeof this.remainTime === 'number' && this.remainTime > 0) {
      this.hasremindetime = true;
      this.day = parseInt(this.remainTime / (1000 * 60 * 60 * 24));
      this.hour = parseInt((this.remainTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minute = parseInt((this.remainTime % (1000 * 60 * 60)) / (1000 * 60));
      this.second = (this.remainTime % (1000 * 60)) / 1000;
      // 倒计时
      console.log(this.day);
      this.countDowm();
    } else {
      this.hasremindetime = false;
    }
    this.loadingSku = true;
    this.getSkuList();
  },
  methods: {
    // 获取课次区间
    getBetween(min, max) {
      if (min === max) {
        return min;
      } else if (min < max) {
        return min + '-' + max;
      }
    },
    // 倒计时
    countDowm() {
      var self = this;
      clearInterval(this.promiseTimer);
      this.promiseTimer = setInterval(function() {
        if (self.hour === 0 && self.minute === 0 && self.second === 0 && self.day !== 0) {
          self.day -= 1;
          self.hour = 24;
        }
        if (self.hour === 0) {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59;
            self.minute -= 1;
          } else if (self.minute === 0 && self.second === 0) {
            self.second = 0;
            clearInterval(self.promiseTimer);
          } else {
            self.second -= 1;
          }
        } else {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59;
            self.minute -= 1;
          } else if (self.minute === 0 && self.second === 0) {
            self.hour -= 1;
            self.minute = 59;
            self.second = 59;
          } else {
            self.second -= 1;
          }
        }
      }, 1000);
    },
    formatNum(num) {
      return num < 10 ? '0' + num : '' + num;
    },
    // 多个数组取交集
    getMoreListCommon(arrs) {
      console.log(arrs);
      var arr = arrs.shift();
      console.log(arr);
      for (var i = arrs.length; i--;) {
        // eslint-disable-next-line one-var
        var p = { 'boolean': {}, 'number': {}, 'string': {}}, obj = [];
        arr = arr.concat(arrs[i]).filter(function(x) {
          var t = typeof x;
          return !((t in p) ? !p[t][x] && (p[t][x] = 1) : obj.indexOf(x) < 0 && obj.push(x));
        });
        if (!arr.length) arr = [];
      }
      console.log(arr);
      if (arr.length === 0) {
        this.skuidsList = [];
        this.isDisabled = true;
      } else {
        this.skuDetails.skuList.forEach(item => {
          arr.forEach(ele => {
            console.log('item', item);
            if (~~item.id === ~~ele) {
              console.log('--------this.quantity', this.quantity, '8888', this.matter);
              if (this.quantity === 1) {
                this.matter = 1;
              }
              this.skuPrice = item.price || 0;
              this.skuPic = item.pic;
              this.stock = item.stock || 0;
              this.courseCount = item.courseCount;
              this.purchaseLimit = item.purchaseLimit || 0;
            }
          });
        });
        this.isDisabled = false;
        this.skuidsList = arr;
      }
    },
    // 外部遮罩层
    changeShow() {
      this.$emit('changeShow', false);
    },
    // sku数据
    async getSkuList() {
      await this.$store.dispatch('GetSkuDetails', this.id).then(res => {
        if (res.code === 200) {
          this.skuDetails = res.data;
          if (this.skuDetails.attributeList.length > 0) {
            this.skuDetails.attributeList.forEach((item, index) => {
              if (Object.prototype.toString.call(item.attributeValueList) === '[object Array]' && item.attributeValueList.length > 0) {
                item.attributeValueList.forEach(m => {
                  this.$set(m, 'check', false);
                  if (this.selectList.length > 0) {
                    let a = m.skuIds.split(',');
                    this.selectList.forEach(sItem => {
                      console.log('sItem.skuIds', sItem.skuIds);
                      if (a.indexOf(sItem.skuIds.toString()) > -1) {
                        if (sItem.check) {
                          this.$set(m, 'check', true);
                        }
                      }
                    });
                  }
                });
              }
            });
          }
        }
        this.changeSpecParamState();
        this.loadingSku = false;
        console.log(this.$refs.wTitles);
        if (this.$refs.wTitles) {
          this.$nextTick(() => {
            console.log(this.$refs.wTitles.offsetHeight);
            let wheight = this.$refs.wTitles.offsetHeight + 10;
            this.$refs.tDetails.style.height = `calc(100% - ${wheight}px)`;
          });
        }
      }).catch(() => {
        this.loadingSku = false;
      });
    },
    // 点击预览的方法
    showskuPre(isDisabled) {
      console.log(isDisabled);
      let imgList = [];// 预览的图片数组
      if (isDisabled || this.skuPic === null) {
        imgList = [this.details.pic];
      } else {
        imgList = [this.skuPic];
      }
      ImagePreview({
        images: imgList,
        showIndex: false
      });
    },
    /*
       1.for 每一个属性值，取交集，判断是否有课
       执行的时机有2种情况下
     */
    changeSpecParamState() {
      for (let i = 0; i < this.skuDetails.attributeList.length; i++) {
        /* 标记除当前规格，具体那些是选中的集合与未选中的集合数据*/
        this.getOtherSpecParam(i);
        for (let j = 0; j < this.skuDetails.attributeList[i].attributeValueList.length; j++) {
          let sonItem = this.skuDetails.attributeList[i].attributeValueList[j];

          /* 当前组属性与---其他所有选中规格属性取交集*/
          let otherCommonSpecParamsId = this.getOtherCommonSpecParamsId(this.selectList, sonItem.skuIds.split(','));
          if ((otherCommonSpecParamsId.length > 0)) {
            this.$set(sonItem, 'isStock', false);
          } else {
            this.$set(sonItem, 'isStock', true);
          }
        }
      }
    },
    /**
     * 2.区分哪些sku被选中与未选中
     * @param bean
     */
    getOtherSpecParam(vindex) {
      this.selectList = [];
      this.unSelectList = [];
      this.skuDetails.attributeList.forEach((item, index) => {
        if (index !== vindex) {
          if (Object.prototype.toString.call(item.attributeValueList) === '[object Array]' && item.attributeValueList.length > 0) {
            item.attributeValueList.forEach(ele => {
              if (ele.check) {
                this.selectList.push(ele);
              } else {
                this.unSelectList.push(ele);
              }
            });
          }
        }
      });
    },
    /**
     * 3.for到具体属性值与其他组所有已选中的属性值取交集
     * @param selectList  除当前属性的其他组被选中skuid的集合
     * @param currentList  当前属性的skuid
     * @return
     */
    getOtherCommonSpecParamsId(selectList, currentList) {
      let list = currentList;
      for (let i = 0; i < selectList.length; i++) {
        let item = selectList[i];
        if (item.check) {
          if (list.length > 0) {
            list = this.getCommonList(item.skuIds.split(','), list);
          }
        }
      }
      return list;
    },
    // 取数组的交集
    getCommonList(a, b) {
      const s = new Set(b);
      return [...new Set(a)].filter(x => s.has(x));
    },
    // sku选择
    changeProper(vindex, val, sindex) {
      this.skuDetails.attributeList[vindex].attributeValueList.forEach((item, index) => {
        if (index === sindex) {
          if (item.check) {
            this.$set(item, 'check', false);
          } else {
            this.$set(item, 'check', true);
          }
        } else {
          this.$set(item, 'check', false);
        }
      });
      this.changeSpecParamState();
    },

    // 立即支付
    async immediatelyPay(ids) {
      console.log('ids', ids);
      let params = {
        ids: ids,
        interfaceType: '2',
        paySource: '2'
      };
      await generateOrder(params).then((result) => {
        //         900019,"订单商品库存不足"
        // 900008,"订单商品全部失效")
        console.log('result', result);
        if (result.data.isZero) {
          this.$router.push({
            name: 'PaySuccess'
          });
        } else {
          this.$router.push({
            name: 'ConfirmOrder',
            query: {
              ids: this.skuidsList.join(','),
              interfaceType: '2'
            }
          });
        }
      }).catch((err) => {
        console.log('err', err);
      });
      this.canCommit = true;
    },

    // 加入选课单
    async add() {
      if (getToken()) {
        if (this.stock === undefined || Number(this.stock) === 0) {
          if (~~this.details.productType === 4 || ~~this.details.productType === 5) {
            Toast('库存不足');
          } else {
            Toast('名额不足');
          }
        } else {
          if (this.canCommit) {
            this.canCommit = false;
            if (this.isImmediatelyJoin) {
              console.log('this.skuPrice', this.skuPrice);
              if (this.skuPrice !== 0) {
                this.canCommit = true;
                let query = {
                  ids: this.skuidsList.join(','),
                  interfaceType: '2'
                };
                if (~~this.details.productType === 4) {
                  query.num = this.matter;
                }
                sessionStorage.removeItem('studentNeedObj');
                this.$router.push({
                  name: 'ConfirmOrder',
                  query
                });
              } else {
                console.log('0元商品');
                console.log('this.skuidsList', this.skuidsList);
                this.immediatelyPay(this.skuidsList);
              }
            } else {
              if (this.skuPrice !== 0 || this.isExchange) {
                if (this.isExchange === true) {
                  let obj;
                  this.skuDetails.skuList.forEach(item => {
                    if (~~item.id === ~~this.skuidsList[0]) {
                      obj = item;
                    }
                  });
                  let emitObj = {
                    obj,
                    skuDetails: this.skuDetails
                  };
                  this.$emit('exchange-sku', JSON.stringify(emitObj));
                  this.canCommit = true;
                } else {
                  if (~~this.productSkuId === 0) {
                    let data = {
                      productId: this.id,
                      productSkuId: this.skuidsList.join(','),
                      quantity: 1
                    };
                    if (this.details.productType === '4') {
                      data.quantity = this.matter;
                    }
                    await this.$store.dispatch('AddCart', data).then(res => {
                      if (res.code === 200) {
                        Toast(res.msg);
                        this.$emit('changeShow', false);
                        this.$emit('changeCartNum');
                      }
                    }).catch(err => {
                      console.log(err);
                    });
                    sessionStorage.setItem('hasCreateOrder', true);
                    this.canCommit = true;
                  } else {
                    let data = {
                      id: this.mainId,
                      productId: this.id,
                      productSkuId: this.skuidsList.join(','),
                      quantity: 1
                    };
                    if (this.details.productType === '4') {
                      data.quantity = this.matter;
                    }
                    await this.$store.dispatch('UpdateCart', data).then(res => {
                      if (res.code === 200) {
                        Toast('修改成功');
                        let sku;
                        this.skuDetails.skuList.forEach(element => {
                          if (element.id === ~~this.skuidsList[0]) {
                            sku = element;
                          }
                        });
                        console.log('sku', sku);
                        if (this.details.productType === '4') {
                          this.$emit('update-productSku', sku, res.data, this.matter);
                        } else {
                          this.$emit('update-productSku', sku, res.data);
                        }
                      }
                    }).catch(err => {
                      console.log(err);
                    });
                    this.canCommit = true;
                  }
                }
              } else {
                let that = this;
                Dialog.confirm({
                  message: '0元商品不允许加入购物车，是否立即报名？',
                  confirmButtonText: '取消',
                  confirmButtonColor: 'rgba(0, 0, 0, 0.45)',
                  cancelButtonText: '确定',
                  cancelButtonColor: '#0F47C1'
                })
                  .then(() => {
                    // on confirm
                    this.canCommit = true;
                  })
                  .catch(() => {
                    // on cancel
                    that.immediatelyPay(this.skuidsList);
                  });
              }
            }
          }
        }
      } else {
        Dialog.confirm({
          title: '提示',
          message: '需要登录才能操作，是否跳转登录页面？',
          confirmButtonColor: '#0F47C1'
        })
          .then(() => {
            // on confirm
            this.$router.replace({ name: 'Login', query: { redirect: this.$route.fullPath }});
          })
          .catch(() => {
            // on cancel
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.course-details {
  width: 100%;
  height: 100%;

  .c-header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 92px;
  }

  .share {
    width: 40px;
    height: 40px;
  }

  .content {
    position: absolute;
    top: 92px;
    bottom: 126px;
    width: 100%;
    height: calc(100% - 218px);
    overflow-y: auto;
  }

  /deep/ .van-goods-action {
    padding: 24px 30px 26px 40px;
    height: auto;

    .van-goods-action-icon {
      min-width: 0;
      margin-right: 40px;
    }

    .van-goods-action-icon__icon {
      margin: 0;
      width: 40px;
      height: 40px;
    }

    .van-goods-action-button--first {
      margin-right: 20px;
      color: $blue;
      border: 1px solid;
      margin-left: 0;
    }

    .wbutton {
      background: $white !important;
    }

    .sbutton {
      font-weight: bold;
    }

    .van-goods-action-button {
      border-radius: 38px;
      font-size: 28px;
      height: 76px;
    }

    .van-goods-action-button--last {
      margin-right: 0;
    }
  }

  .goods {
    position: relative;

    .svg-icon {
      vertical-align: bottom;
      width: 100%;
      height: 100px;
    }
  }

  .intro-img {
    display: block;
    width: 100%;
    height: 418px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .time {
    position: absolute;
    bottom: 0;
    justify-content: space-between;
    line-height: 100px;
    width: 100%;
    height: 100px;
    padding: 0 30px;
    color: #fefffe;
    font-size: 28px;
    box-sizing: border-box;

    @extend .flex-and-m;

    .timeout {
      @extend .flex-and-m;
    }
  }

  .desc {
    margin-right: 10px;
  }

  span.timer {
    background: $black;
    width: 54px;
    height: 50px;
    display: inline-block;
    line-height: 50px;
    text-align: center;
    border-radius: 8px;
    margin-right: 8px;
  }

  span.dt {
    font-size: 28px;
    margin-right: 8px;
  }

  span.dt:last-of-type {
    margin-right: 0;
  }

  .pay {
    font-size: 40px;
    font-weight: bold;
    max-width: 208px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    label {
      margin-right: 10px;
    }
  }
}

.description {
  padding: 20px 30px;

  .block {
    background: $white;
    border-radius: 20px;
    padding: 30px;
    font-size: 32px;
    box-shadow: 0 4px 20px 0 rgba($dark-black, 0.1);
  }

  .jc {
    margin-top: 20px;

    h3 {
      font-size: 32px;
      color: lighten($black, 15%);
    }

    p {
      width: 100%;
      white-space: inherit;
      font-size: 0;
    }

    img {
      width: 100%;
      vertical-align: middle;
    }
  }

  .xq {
    margin-top: 20px;

    h3 {
      font-size: 32px;
      margin-bottom: 20px;
      color: lighten($black, 15%);
    }

    p {
      white-space: inherit;
    }

    img {
      width: 100%;
      vertical-align: middle;
    }
  }

  .line-title {
    line-height: 52px;
    font-weight: bold;
    color: rgba($dark-black, 0.85);
  }

  .activity {
    color: $red;
    background: rgba($red, 0.1);
    border-radius: 10px;
    height: 66px;
    line-height: 66px;
    font-size: 24px;
    justify-content: space-between;
    padding: 0 20px;
    margin-top: 24px;

    @extend .flex-and-m;

    .to-active-page {
      @extend .flex-and-m;
    }
  }
}

.buy {
  display: flex;
  justify-content: space-between;
  font-size: 26px;
  color: rgba($dark-black, 0.45);
  padding: 12px 4px 24px;
}

/deep/ .van-share-sheet__options {
  padding: 32px 0;

  .van-share-sheet__option {
    width: 50%;
  }
}

.course-title {
  height: 92px;
  width: 100%;
  background: $white;
  justify-content: space-between;
  padding: 0 32px;
  box-shadow: 0 4px 20px 0 rgba($dark-black, 0.1);
  z-index: 9999;

  @extend .flex-and-m;

  .van-icon {
    font-size: 40px;
  }

  .types {
    span.type-title {
      padding: 0 50px;
      font-size: 30px;
      color: rgba($dark-black, 0.45);
      font-weight: bold;
      position: relative;
    }

    span.active-types {
      color: rgba($dark-black, 0.85);

      &::after {
        position: absolute;
        content: '';
        width: 22px;
        height: 6px;
        background: $blue;
        border-radius: 4px;
        bottom: -14px;
        left: calc(50% - 11px);
      }
    }
  }
}

.wrapper {
  position: absolute;
  width: 100%;
  height: 85%;
  bottom: 0;
  background-color: $white;

  @extend .flex-w;
}

.short {
  height: 70%;

  .short-tip {
    color: rgba($dark-black, 0.65);
    font-weight: bold;
    font-size: 32px;
    text-align: center;
    padding: 8px 0 22px;
  }
}

.w-block {
  width: 100%;
  height: 66px;
}

/deep/ .van-notice-bar {
  background-color: rgba($red, 0.1);
  color: $red;
  font-size: 24px;
  height: 66px;
  line-height: 66px;

  .van-notice-bar__wrap {
    @extend .flex-c;
  }
}

.close {
  position: absolute;
  right: 20px;
  top: 96px;
  font-size: 52px;
  color: #e0e0e0;
  z-index: 999;
}

.w-content {
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  padding: 30px 0 0;
  top: 66px;
  bottom: 128px;
  touch-action: pan-y;
  .pro-simple {
    width: 100%;

    @extend .flex-and-m;

    flex-wrap: nowrap;
    padding-bottom: 22px;

    .pro-img {
      display: inline-block;
      width: 180px;
      height: 101px;
      cursor: pointer;
      border-radius: 10px;
    }

    .price {
      width: calc(100% - 220px);
      height: 56px;
      font-size: 40px;
      font-weight: bold;
      color: $red;
      margin-left: 20px;

      @extend %one-line-text-overflow;
    }
  }
  .s-title {
    padding: 30px 0 20px;
    font-size: 26px;
    color: rgba($dark-black, 0.65);
  }

  .w-type {
    .s-type {
      @extend .flex-and-m;
      @extend .flex-w;

      span {
        position: relative;
        margin-bottom: 10px;
        margin-right: 30px;
        font-size: 28px;
      }

      label {
        display: inline-block;
        height: 72px;
        line-height: 70px;
        padding: 0 30px;
        text-align: center;
        border: 1px solid #e0e0e0;
        color: rgba($dark-black, 0.65);
        border-radius: 10px;

        @extend %one-line-text-overflow;
      }
    }

    .active-s-type,
    .active-s-time {
      label {
        background-color: rgba($blue, 0.1);
        color: $blue;
        border: 1px solid;
      }

      small {
        background: $blue;
      }
    }

    .active-s-teacher {
      img {
        border: 1px solid $blue;
      }

      .t-name {
        color: $blue;
      }

      small {
        background: $blue;
      }
    }
  }

  small {
    position: absolute;
    height: 38px;
    width: 75px;
    background: #ccc;
    color: #fff;
    font-size: 24px;
    border: 1px solid #fff;
    transform: scale(0.8);
    text-align: center;
    right: 0;
    border-radius: 10px 0 10px 0;
    top: -20px;
  }

  .w-title {
    color: rgba($dark-black, 0.85);
    font-size: 32px;
    line-height: 52px;
    font-weight: bold;

    @extend .text-overflow;
  }

  .buy {
    font-size: 28px;
    padding-top: 18px;
    border-bottom: 1px solid rgba(#e0e0e0, 50%);
  }
}

.no-timer {
  top: 0;
}

.no-timer-icon {
  top: 20px;
}

.w-titles {
  padding: 0 40px;
}

.t-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  p.t-block {
    display: flex;
    width: 200px;
    margin-right: 34px;
    flex-direction: column;
    position: relative;
    align-items: center;

    .t-name {
      font-size: 28px;
      padding: 20px 0 30px;
      text-align: center;
      color: rgba(0, 0, 0, 0.65);
      height: 90px;
    }
  }

  img.teacher-avatar {
    display: inline-block;
    width: 200px;
    height: 200px;
    border-radius: 10px;
  }
}

.w-footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 126px;
  border-top: 1px solid rgba(#e0e0e0, 0.5);
  background-color: #fefffe;

  @extend .flex-and-m;
  @extend .flex-c;

  button {
    width: 100%;
    margin: 0 30px;
    border-radius: 38px;
    background: $blue;
  }
}

.t-details {
  height: calc(100% - 220px);
  padding-left: 40px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}

/deep/ .n-loading {
  padding-top: 20vh;
  z-index: 999;
}

/deep/ .sku-loading {
  padding-top: 50vh;
  z-index: 999;
}
.hide-small {
  display: none !important;
}
.show-small {
  display: flex !important;
}
.product-matter {
  width: 100%;
  &-operate {
    margin-bottom: 20px;
  }
  /deep/ .van-stepper {
    display: inline-block;
  }
  /deep/ .van-stepper__input {
    color: #333333;
    font-size: 28px;
    font-weight: bold;
    background: #F8F8F8;
  }
  &-label {
    font-size: 28px;
    font-weight: 400;
    color: rgba(0,0,0,0.45);
    margin-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/courseSku.vue